/* eslint
    prefer-const: "warn",
    object-shorthand: "warn",
    @typescript-eslint/no-use-before-define: "warn",
    no-inner-declarations: "warn",
    dot-notation: "off"
*/


namespace Easyfy.Shared.Scripts {
  export interface IGtmEvent {
    event: string;
    ecommerce: object;
  }

  export interface IActionField {
    list: string;
  }

  export interface ICheckoutActionField {
    step: number;
    option: string;
  }
  export interface IGtmImpressionProduct extends ProductBase {
    position: number;
    list: string;
  }

  export interface IGtmClickProduct extends ProductBase {
    position: number;
    dimension6: string; // depict-recommendation
  }

  export interface IGtmBasketProduct extends ProductBase {
    quantity: number;
  }

  export interface IGtmDetailProduct extends ProductBase { }

  interface ProductBase {
    name: string;
    id: string;
    price: number;
    brand: string,
    category: string;
    variant: string;
    dimension3: string; // product-type
    dimension4: string; // ean
    dimension5: string; // all-categories
    dimension7: string; // prescriptive (excluded for facebook)
  }


  export interface IGtmProductImpressionEvent {
    impressions: IGtmImpressionProduct[];
    currencyCode: string;
  }

  export interface IGtmProductClickEvent {
    click: {
      actionField: IActionField;
      products: IGtmClickProduct[];
      currencyCode: string;
    }
  }

  export interface IGtmProductDetailEvent {
    detail: {
      actionField: IActionField;
      products: IGtmDetailProduct[];
      currencyCode: string;
    }
  }

  export interface IGtmProductRemoveEvent {
    remove: {
      actionField: IActionField;
      products: IGtmBasketProduct[];
    }
  }

  export interface IGtmProductAddEvent {
    add: {
      actionField: IActionField;
      products: IGtmBasketProduct[];
      currencyCode: string;
    }
  }

  export interface IGtmCheckoutEvent {
    checkout: {
      actionField: ICheckoutActionField;
      products: IGtmBasketProduct[];
    }
  }

  export const PushProductImpressionEvent = async (eventProducts: IGtmImpressionProduct[], listName: string, currencyCode: string): Promise<any> => {
    const impressionEvent: IGtmProductImpressionEvent = {
      impressions: eventProducts,
      currencyCode
    };
    const gtmEvent: IGtmEvent = {
      event: "impressions",
      ecommerce: impressionEvent
    }
    PushToDataLayer(gtmEvent);
  };

  export const PushProductClickEvent = async (eventProducts: IGtmClickProduct[], listName: string, currencyCode: string): Promise<any> => {
    const clickEvent: IGtmProductClickEvent = {
      click: {
        actionField: {
          list: ListNameCleanUp(listName)
        },
        products: eventProducts,
        currencyCode
      }
    };
    const gtmEvent: IGtmEvent = {
      event: "productClick",
      ecommerce: clickEvent
    }
    PushToDataLayer(gtmEvent);
  };

  export const PushProductDetailEvent = async (eventProducts: IGtmDetailProduct[], listName: string, currencyCode): Promise<any> => {
    const detailEvent: IGtmProductDetailEvent = {
      detail: {
        actionField: {
          list: ListNameCleanUp(listName)
        },
        products: eventProducts,
        currencyCode
      }
    };
    const gtmEvent: IGtmEvent = {
      event: "productDetail",
      ecommerce: detailEvent
    }
    PushToDataLayer(gtmEvent);
  };

  export const PushProductAddEvent = async (eventProducts: IGtmBasketProduct[], listName: string, currencyCode: string): Promise<any> => {
    const removeEvent: IGtmProductAddEvent = {
      add: {
        actionField: {
          list: ListNameCleanUp(listName)
        },
        products: eventProducts,
        currencyCode
      }
    };
    const gtmEvent: IGtmEvent = {
      event: "addToCart",
      ecommerce: removeEvent
    }
    PushToDataLayer(gtmEvent);
  };

  export const PushProductRemoveEvent = async (eventProducts: IGtmBasketProduct[], listName: string): Promise<any> => {
    const removeEvent: IGtmProductRemoveEvent = {
      remove: {
        actionField: {
          list: ListNameCleanUp(listName)
        },
        products: eventProducts,
      }
    };
    const gtmEvent: IGtmEvent = {
      event: "removeFromCart",
      ecommerce: removeEvent
    }
    PushToDataLayer(gtmEvent);
  };

  export const PushCheckoutEvent = async (eventProducts: IGtmBasketProduct[], step: number, option: string): Promise<any> => {
    const checkoutEvent: IGtmCheckoutEvent = {
      checkout: {
        actionField: {
          step,
          option
        },
        products: eventProducts,
      }
    };
    const gtmEvent: IGtmEvent = {
      event: "checkout",
      ecommerce: checkoutEvent
    }
    PushToDataLayer(gtmEvent);
  };

  export const HandleDataEvents = async (response: any): Promise<any> => {
    if (response?.data?.dataLayer) {
      BuildAndPushEvents(response.data.dataLayer);
    }
    return response;
  };

  export const BuildAndPushEvents = async (dataEvents: any): Promise<any> => {
    if (!dataEvents) return;

    dataEvents.forEach(dataEvent => {
      if (!dataEvent?.eventName) return;

      switch (dataEvent.eventName) {
        case 'addToCart': {
          const products: IGtmBasketProduct[] = [];
          dataEvent.products.forEach(dataProduct => {
            const product: IGtmBasketProduct = {
              brand: dataProduct.brand,
              category: dataProduct.category,
              id: dataProduct.id,
              name: dataProduct.name,
              price: dataProduct.price,
              variant: dataProduct.variant,
              quantity: dataProduct.quantity,
              dimension3: dataProduct.dimension3,
              dimension4: dataProduct.dimension4,
              dimension5: dataProduct.dimension5,
              dimension7: dataProduct.dimension7
            };
            products.push(product);
          });
          PushProductAddEvent(products, dataEvent.listName, dataEvent.currencyCode);
          break;
        }
        case 'removeFromCart': {
          const products: IGtmBasketProduct[] = [];
          dataEvent.products.forEach(dataProduct => {
            const product: IGtmBasketProduct = {
              brand: dataProduct.brand,
              category: dataProduct.category,
              id: dataProduct.id,
              name: dataProduct.name,
              price: dataProduct.price,
              variant: dataProduct.variant,
              quantity: dataProduct.quantity,
              dimension3: dataProduct.dimension3,
              dimension4: dataProduct.dimension4,
              dimension5: dataProduct.dimension5,
              dimension7: dataProduct.dimension7
            };
            products.push(product);
          });
          PushProductRemoveEvent(products, dataEvent.listName)
          break;
        }
        case 'productClick': {
          const clickProducts: IGtmClickProduct[] = [];
          dataEvent.products.forEach(dataProduct => {
            const clickProduct: IGtmClickProduct = {
              brand: dataProduct.brand,
              category: dataProduct.category,
              id: dataProduct.id,
              name: dataProduct.name,
              price: dataProduct.price,
              variant: dataProduct.variant,
              position: dataProduct.position,
              dimension3: dataProduct.dimension3,
              dimension4: dataProduct.dimension4,
              dimension5: dataProduct.dimension5,
              dimension6: "",
              dimension7: dataProduct.dimension7
            };
            clickProducts.push(clickProduct);
          });
          PushProductClickEvent(clickProducts, dataEvent.listName, dataEvent.currencyCode)
          break;
        }
        case 'impressions': {
          const impressionProducts: IGtmImpressionProduct[] = [];
          dataEvent.products.forEach(dataProduct => {
            const impressionProduct: IGtmImpressionProduct = {
              brand: dataProduct.brand,
              category: dataProduct.category,
              id: dataProduct.id,
              name: dataProduct.name,
              price: dataProduct.price,
              variant: dataProduct.variant,
              position: dataProduct.position,
              list: ListNameCleanUp(dataProduct.list),
              dimension3: dataProduct.dimension3,
              dimension4: dataProduct.dimension4,
              dimension5: dataProduct.dimension5,
              dimension7: dataProduct.dimension7
            };
            impressionProducts.push(impressionProduct);
          });
          PushProductImpressionEvent(impressionProducts, dataEvent.listName, dataEvent.currencyCode)
          break;
        }
        case 'checkout': {
          const products: IGtmBasketProduct[] = [];
          dataEvent.products.forEach(dataProduct => {
            const product: IGtmBasketProduct = {
              brand: dataProduct.brand,
              category: dataProduct.category,
              id: dataProduct.id,
              name: dataProduct.name,
              price: dataProduct.price,
              variant: dataProduct.variant,
              quantity: dataProduct.quantity,
              dimension3: dataProduct.dimension3,
              dimension4: dataProduct.dimension4,
              dimension5: dataProduct.dimension5,
              dimension7: dataProduct.dimension7
            };
            products.push(product);
          });
          PushCheckoutEvent(products, dataEvent.step, dataEvent.option)
          break;
        }
        case 'productDetail': {
          const detailProducts: IGtmDetailProduct[] = [];
          dataEvent.products.forEach(dataProduct => {
            const detailProduct: IGtmDetailProduct = {
              brand: dataProduct.brand,
              category: dataProduct.category,
              id: dataProduct.id,
              name: dataProduct.name,
              price: dataProduct.price,
              variant: dataProduct.variant,
              dimension3: dataProduct.dimension3,
              dimension4: dataProduct.dimension4,
              dimension5: dataProduct.dimension5,
              dimension7: dataProduct.dimension7
            };
            detailProducts.push(detailProduct);
          });
          PushProductDetailEvent(detailProducts, dataEvent.listName, dataEvent.currencyCode)
          break;
        }
        default: {
          console.warn("Faulty data event: propterties name?")
          console.dir(dataEvent);
        }
      }
    });
  };

  async function PushToDataLayer(gtmEvent: any): Promise<any> {
    if (!gtmEvent) return;
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(gtmEvent);

    /* - For debugging the dataLayer - */
    // console.group('%c GA DataLayer ', 'color: #bada55');
    // console.dir(window['dataLayer']);
    // console.groupEnd();
  }

  const ListNameCleanUp = (listname: string): string => {
    if (!listname) return null;
    const cleanedListName = listname.replace(/\s+/g, '').replace('&', '').toLowerCase();

    return cleanedListName;
  };
}

export default Easyfy.Shared.Scripts;